import { isEqual } from 'lodash-es'
import type { LegendContentResource } from '@/features/legends/api/resources/legend'

/**
 * The top-level fields of `next` whose value differs from `previous`.
 *
 * @param previous What the server has.
 * @param next
 * @returns `null` when a field `previous` has is gone from `next`. A patch
 * can't send that: the API merges the patch over what it has, so a field left
 * out keeps its value, and `null` would be saved as the value.
 */
export function diffLegendContentResources(
  previous: LegendContentResource,
  next: LegendContentResource,
): Partial<LegendContentResource> | null {
  const changes: Partial<LegendContentResource> = {}
  // SAFETY: the keys are the resources' own.
  const keys = new Set([...Object.keys(previous), ...Object.keys(next)]) as Set<
    keyof LegendContentResource
  >
  for (const key of keys) {
    if (isEqual(previous[key], next[key])) {
      continue
    }
    if (next[key] === undefined) {
      return null
    }
    Object.assign(changes, { [key]: next[key] })
  }
  return changes
}
